import '../App.css';
import Document from './TestDocument';
import MainToolbar from './TestMainToolbar';
import { defaultTheme, Provider, Flex, Button, DialogTrigger, AlertDialog } from '@adobe/react-spectrum';
import { useEffect, useState } from 'react';
import Questions from './TestQuestions';
import { db } from '../firebase.js';
import { collection, query, or, getDoc, getDocs, where, Timestamp, getCountFromServer, orderBy } from 'firebase/firestore';
import { logTest } from '../logging';


function TestInterface({ currentIndex, workerId, participantId, experiment, condition, numMins, highlights, passage, startTime, questions, maxWordCount, callbacks }) {

  const [isOpenBook, setIsOpenBook] = useState(true); // TODO: replace with a read from the database
  const timeLimit = numMins * 60 * 1000; // minutes
  const [instructions, setInstructions] = useState("")

  const [numAnsweredQuestions, setNumAnsweredQuestions] = useState(0);
  const [testResponses, setTestResponses] = useState(Array(questions.length).fill({}));
  const [formValidated, setFormValidated] = useState(false);

  useEffect(() => {
    var isValid = true;
    var numAnswered = 0;
    testResponses.forEach(element => {
      if (Object.keys(element).length === 0) {
        isValid = isValid && false;
      }
      else {
        numAnswered++;
      }
    });
    setNumAnsweredQuestions(numAnswered);
    setFormValidated(isValid);
  }, [testResponses]);


  useEffect(() => {
    if (isOpenBook && maxWordCount === 0) {
      setInstructions("Answer the questions based on the document you read previously in the allocated time.");
    }
    else if (isOpenBook) {
      setInstructions("Answer the questions on the right based on the document in the allocated time. You may refer back to the document and your prior highlights at any time.");
    }
    else {
      setInstructions("Answer the questions based on the document you read previously in the allocated time.");
    }
  }, [isOpenBook]);

  function submitForm() {
    if (experiment === "exp2-highlights") {
      let result = {
        timestamp: Date.now(),
        workerId: workerId,
        participantId: participantId,
        experiment: experiment,
        condition: condition,
        testResponses: testResponses,
      }
      logTest(result, callbacks);
    }

    else if (experiment === "exp3-withinHighlights") {
      let result = {
        testEndTime: Date.now(),
        workerId: workerId,
        participantId: participantId,
        experiment: experiment,
        condition: condition,
        currentIndex: currentIndex,
        testResponses: testResponses,
      }
      logTest(result, callbacks);
    }

    else {
      var results = {
        testResponses: testResponses,
        participantId: participantId,
      }
      logTest(results, callbacks);
    }

  }

  return (
    <div style={{ backgroundColor: "#f8f8f8" }}>
      <Provider theme={defaultTheme} colorScheme='light'>
        <Flex direction="column" justifyContent={'start'} gap="2000px">
          <MainToolbar startTime={startTime} timeLimit={timeLimit} instructions={instructions} numAnsweredQuestions={numAnsweredQuestions} experiment={experiment} submitForm={submitForm} />
          {isOpenBook ?
            <>
              <Flex direction="row" justifyContent={'center'} gap="size-200" marginStart="size-200" marginEnd="size-200">
                <Document passage={passage} highlights={highlights} />
                <Questions width="size-400" currentIndex={currentIndex} splitView={true} questions={questions} testResponses={testResponses} setTestResponses={setTestResponses} setFormValidated={setFormValidated} participantId={participantId} workerId={workerId} condition={condition} experiment={experiment} />
              </Flex>
            </>
            :
            <>
              <Flex direction="row" justifyContent={'center'} gap="size-200" marginStart="size-200" marginEnd="size-200">
                <Questions width="size-400" splitView={false} questions={questions} setFormValidated={setFormValidated} />
              </Flex>
            </>
          }

        </Flex>

        <DialogTrigger>
          <Button variant='primary' style='fill' position='fixed' bottom='size-50' right='size-300' isDisabled={!formValidated}>Finish Test</Button>
          <AlertDialog
            variant="confirmation"
            title="Are you sure you want to submit your answers?"
            primaryActionLabel="Finish Test"
            cancelLabel="Cancel"
            autoFocusButton="primary"
            onPrimaryAction={() => {
              // done to fix this issue: https://github.com/testing-library/react-testing-library/issues/1165
              const id = setTimeout(() => {
                submitForm();
              }, 700);
              return () => clearTimeout(id);
            }}
          >
            {experiment === "exp3-withinHighlights" && currentIndex === 0 ?
              "If you have finished the test, you will be given a break before starting the next test."
              : experiment === "exp3-withinHighlights" && currentIndex > 0 ?
                // "If you have finished the test, the experiment will end."
                // : 
                "If you have finished the test, you will be asked to answer a couple of questions about your experience."
                : null
            }


          </AlertDialog>
        </DialogTrigger>


      </Provider>
    </div>
  );
}

export default TestInterface;